import request from '@/utils/request'

/**
 * 查询全部地点
 * @param {*} data
 * @returns
 */
export function allPlace (data) {
  return request({
    url: '/zstp/neo4j/get_all_address/',
    method: 'post',
    data
  })
}

/**
 * 地点关系
 * @param {*} data
 * @returns
 */
export function addressRelation (data, others = {}) {
  return request({
    url: '/zstp/neo4j/address_relation/',
    method: 'post',
    ...others,
    data
  })
}

/**
 * 地点详情
 * @param {*} data
 * @returns
 */
export function addressDetail (data) {
  return request({
    url: '/zstp/neo4j/address_detail/',
    method: 'post',
    data
  })
}

/**
 * 查询名称对应的人物列表
 * @param {*} data
 * @returns
 */
export function namePerson (data) {
  return request({
    url: '/zstp/neo4j/get_name_person/',
    method: 'post',
    data
  })
}
